import { render, staticRenderFns } from "./pamerdatahies.vue?vue&type=template&id=57eee74e"
import script from "./pamerdatahies.vue?vue&type=script&lang=js"
export * from "./pamerdatahies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports